/**
 * @generated SignedSource<<b80b8dd55e99181425e1e361a05488ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationFormInventorySample_viewer$data = {
  readonly attributes: {
    readonly material: ReadonlyArray<{
      readonly child: ReadonlyArray<{
        readonly child: ReadonlyArray<{
          readonly label: string | null;
          readonly status: string | null;
          readonly value: string | null;
        } | null> | null;
        readonly label: string | null;
        readonly status: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly label: string | null;
      readonly status: string | null;
      readonly value: string | null;
    } | null> | null;
    readonly period: ReadonlyArray<{
      readonly child: ReadonlyArray<{
        readonly child: ReadonlyArray<{
          readonly child: ReadonlyArray<{
            readonly label: string | null;
            readonly status: string | null;
            readonly value: string | null;
          } | null> | null;
          readonly label: string | null;
          readonly status: string | null;
          readonly value: string | null;
        } | null> | null;
        readonly label: string | null;
        readonly status: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly label: string | null;
      readonly status: string | null;
      readonly value: string | null;
    } | null> | null;
    readonly stoneCut: ReadonlyArray<{
      readonly label: string | null;
      readonly status: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CategoryL2L3Select_viewer" | "ItemCondition_viewer">;
  readonly " $fragmentType": "SellerApplicationFormInventorySample_viewer";
};
export type SellerApplicationFormInventorySample_viewer$key = {
  readonly " $data"?: SellerApplicationFormInventorySample_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationFormInventorySample_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": "label",
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": "value",
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "AttributeOption",
    "kind": "LinkedField",
    "name": "child",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "AttributeOption",
        "kind": "LinkedField",
        "name": "child",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "vertical"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./SellerApplicationFormInventorySampleRefetchQuery.graphql')
    }
  },
  "name": "SellerApplicationFormInventorySample_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "vertical",
          "variableName": "vertical"
        }
      ],
      "concreteType": "Attributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeOption",
          "kind": "LinkedField",
          "name": "material",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeOption",
          "kind": "LinkedField",
          "name": "period",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AttributeOption",
              "kind": "LinkedField",
              "name": "child",
              "plural": true,
              "selections": (v4/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeOption",
          "kind": "LinkedField",
          "name": "stoneCut",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CategoryL2L3Select_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemCondition_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "9b190b85a09eb29a91cd20b00b7b9c52";

export default node;
